import React from 'react';
import { FiDownload, FiFile } from 'react-icons/fi';

const DetailFabrikasi = ({ workOrder }) => {
  if (workOrder.category !== 'Fabrikasi' || !workOrder.fabrikasiDetails) {
    return null;
  }

  const details = workOrder.fabrikasiDetails;

  return (
    <div className="bg-[var(--bg-primary)] p-4 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
      <h3 className="text-base font-semibold text-[var(--text-primary)] mb-3">
        Detail Fabrikasi
      </h3>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        <div>
          <p className="text-xs text-[var(--text-secondary)]">Material</p>
          <p className="text-sm text-[var(--text-primary)] font-medium">{details.materialType || '-'}</p>
        </div>
        <div>
          <p className="text-xs text-[var(--text-secondary)]">Ketebalan</p>
          <p className="text-sm text-[var(--text-primary)] font-medium">{details.materialThickness || 0} mm</p>
        </div>
        <div>
          <p className="text-xs text-[var(--text-secondary)]">Dimensi</p>
          <p className="text-sm text-[var(--text-primary)] font-medium">{details.dimensions || '-'}</p>
        </div>
        <div>
          <p className="text-xs text-[var(--text-secondary)]">Berat</p>
          <p className="text-sm text-[var(--text-primary)] font-medium">{details.weight || 0} kg</p>
        </div>
        <div>
          <p className="text-xs text-[var(--text-secondary)]">Pengelasan</p>
          <p className="text-sm text-[var(--text-primary)] font-medium">{details.weldingType || '-'}</p>
        </div>
        <div>
          <p className="text-xs text-[var(--text-secondary)]">Perlakuan</p>
          <p className="text-sm text-[var(--text-primary)] font-medium">{details.surfaceTreatment || '-'}</p>
        </div>
        <div>
          <p className="text-xs text-[var(--text-secondary)]">Jumlah</p>
          <p className="text-sm text-[var(--text-primary)] font-medium">{details.quantity || 1}</p>
        </div>
        <div>
          <p className="text-xs text-[var(--text-secondary)]">Satuan</p>
          <p className="text-sm text-[var(--text-primary)] font-medium">{details.unit || 'unit'}</p>
        </div>
      </div>

      {/* BLUEPRINT SNIPPET */}
      {details.blueprint && (
        <div className="mt-4 pt-4 border-t border-[var(--border-color)]">
          <h4 className="text-xs font-semibold text-[var(--text-secondary)] mb-2">
            Gambar Kerja / Blueprint
          </h4>
          <div className="relative group inline-block">
            {details.blueprint.startsWith('data:image') ? (
              <img
                src={details.blueprint}
                alt="Blueprint"
                className="w-48 h-32 object-cover rounded-lg border border-[var(--border-color)] cursor-pointer"
              />
            ) : (
              <div className="w-48 h-32 bg-[var(--bg-secondary)] rounded-lg border border-[var(--border-color)] flex flex-col items-center justify-center gap-1">
                <FiFile size={28} className="text-red-500" />
                <span className="text-[10px] text-[var(--text-secondary)]">PDF Blueprint</span>
              </div>
            )}
            
            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all rounded-lg flex items-center justify-center">
              <a
                href={details.blueprint}
                download={`Blueprint-${workOrder.woNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-lg"
                title="Download Blueprint"
              >
                <FiDownload size={18} className="text-gray-700" />
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailFabrikasi;